module.exports = __webpack_public_path__ + "img/img18.bb5aac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img18.png
// module id = 258
// module chunks = 0